import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { z } from "zod";

export const useBclProductFormSchema = () => {
  const { t } = useTranslation("product");

  const schema = useMemo(
    () =>
      z.object({
        product_id: z
          .string()
          .min(
            1,
            t(
              "integrationProductListPage.bclModal.validations.productIdRequired"
            )
          )
      }),
    [t]
  );

  return schema;
};

export type BclProductFormSchema = z.infer<
  ReturnType<typeof useBclProductFormSchema>
>;
